import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { AuthService } from "../services/auth.service";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, public auth: AuthService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    console.log("AuthGuard 실행 - 경로:", state.url);

    // 로그인 상태 확인
    const isLoggedIn = this.auth.isLoggedIn();
    console.log("로그인 상태:", isLoggedIn);

    if (isLoggedIn) {
      // 현재 사용자 정보 확인
      const user = await this.auth.getCurrentUser();
      console.log("현재 사용자:", user);

      if (user) {
        console.log("AuthGuard 통과 - 사용자 인증됨");
        return true;
      } else {
        console.log("AuthGuard 실패 - 사용자 정보 없음");
        // 사용자 정보가 없으면 로그인 페이지로 리다이렉트
        this.router.navigateByUrl("/auth/login");
        return false;
      }
    } else {
      console.log("AuthGuard 실패 - 로그인되지 않음");
      // 로그인되지 않은 상태면 로그인 페이지로 리다이렉트
      this.router.navigateByUrl("/auth/login");
      return false;
    }
  }
}
